import React from 'react';
import { AlertCircle, Check } from 'lucide-react';

interface TriggerWordsGuideProps {
  missingTriggerWords: string[];
  handleTriggerClick: (trigger: string) => void;
  requiredTriggers: string[];
}

export const TriggerWordsGuide = ({ requiredTriggers, missingTriggerWords, handleTriggerClick }: TriggerWordsGuideProps) => {
    const allTriggersPresent = missingTriggerWords.length === 0;
    
    return (
      <div className={`mb-4 rounded-lg border p-4 transition-all duration-300 
        ${allTriggersPresent 
          ? 'border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800' 
          : 'border-yellow-200 bg-yellow-50 dark:border-yellow-900/50 dark:bg-yellow-900/20 [.animate-bounce-horizontal_&]:border-red-500 [.animate-bounce-horizontal_&]:shadow-lg [.animate-bounce-horizontal_&]:shadow-red-500/30'
        }`}>
        <div className="flex items-start">
          {allTriggersPresent ? (
            <Check className="mr-2 h-5 w-5 text-green-600 dark:text-green-500" />
          ) : (
            <AlertCircle className="mr-2 h-5 w-5 text-yellow-600 dark:text-yellow-500" />
          )}
          <div>
            <h4 className={`text-sm font-medium ${
              allTriggersPresent
                ? 'text-gray-800 dark:text-gray-200'
                : 'text-yellow-800 dark:text-yellow-400'
            }`}>
              Required Trigger Words
            </h4>
            <div className="mt-2 flex flex-wrap gap-2">
              {requiredTriggers.map((trigger) => (
                <button
                  key={trigger}
                  onClick={() => handleTriggerClick(trigger)}
                  className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium
                    ${missingTriggerWords.includes(trigger)
                      ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400 hover:bg-red-200 dark:hover:bg-red-900/50'
                      : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 hover:bg-green-200 dark:hover:bg-green-900/50'
                    } transition-colors duration-200 cursor-pointer`}
                >
                  {trigger}
                  {missingTriggerWords.includes(trigger) && (
                    <span className="ml-1.5">●</span>
                  )}
                </button>
              ))}
            </div>
            {missingTriggerWords.length > 0 && (
              <p className="mt-2 text-xs text-yellow-600 dark:text-yellow-500">
                Click on the trigger words to add them to your prompt or type them manually.
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };